import SolicitacaoImportacao from './componentes/SolicitacaoImportacao.vue';
import SolicitacaoImportacaoLista from './componentes/SolicitacaoImportacaoLista.vue';
import SolicitacaoImportacaoForm from './componentes/SolicitacaoImportacaoForm.vue';
import SolicitacaoImportacaoRelatorio from './componentes/SolicitacaoImportacaoRelatorio.vue';

export default {
  path: '/solicitacao-importacao-projeto',
  component: SolicitacaoImportacao,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoImportacaoLista,
      name: 'solicitacao-importacao-projeto',
    },
    {
      path: 'nova',
      component: SolicitacaoImportacaoForm,
      name: 'solicitacao-importacao-projeto.nova'
    },
    ,
    {
      path: ':idCript',
      component: SolicitacaoImportacaoForm,
      name: 'solicitacao-importacao-projeto.editar'
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoImportacaoRelatorio,
      name: 'solicitacao-importacao-projeto.relatorio'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-importacao-projeto/rotas.js